import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "/api/v2/"
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.location.replace("/");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
